'use strict';

module.exports = require('./is-implemented')() ? Symbol : require('./polyfill');



/*****************
 ** WEBPACK FOOTER
 ** ./~/es6-symbol/index.js
 ** module id = 43
 ** module chunks = 0
 **/